import type { RootState } from '@/store/root-reducer';

const selectProfilesState = (state: RootState) => state.profiles;

export const selectRows = (state: RootState) => selectProfilesState(state).rows;
export const selectTotal = (state: RootState) => selectProfilesState(state).total;
export const selectLoading = (state: RootState) => selectProfilesState(state).loading;
export const selectError = (state: RootState) => selectProfilesState(state).error;
export const selectPage = (state: RootState) => selectProfilesState(state).page;
export const selectPageSize = (state: RootState) => selectProfilesState(state).pageSize;
export const selectFilters = (state: RootState) => selectProfilesState(state).filters;
export const selectSort = (state: RootState) => selectProfilesState(state).sort;
export const selectDeactivate = (state: RootState) => selectProfilesState(state).deactivate;
